export default __webpack_public_path__ + "images/f12ae74b157fa357fa63657e1137d10f.svg";